import React from 'react';
import Lottie from 'lottie-react';
import { useTheme } from '../ThemeContext';
import wedding from '../Animations/wedding.json';
import truck from '../Animations/truck.json';
import heart from '../Animations/heart.json';

const CARD_WIDTH = 300;
const ACCENT_COLOR = '#441B77';

const FeatureCarousel = () => {
  const { currentTheme, themes } = useTheme();
  const theme = themes[currentTheme];

  const features = [
    {
      title: 'Destination Weddings',
      id: 1,
      animation: wedding,
    },
    {
      title: 'Honeymoon Special',
      id: 2,
      animation: heart,
    },
    {
      title: 'Group Tour Plans',
      id: 3,
      animation: truck,
    },
  ];

  const styles = {
    wrapper: {
      width: '100%',
      maxWidth: '100%',
      margin: '0 auto',
      padding: '20px',
      overflow: 'hidden',
      position: 'relative',
      backgroundColor: theme.bgColor, // Using theme background
      fontFamily: 'Poppins, sans-serif', // Apply Poppins font to the entire wrapper
    },
    track: {
      display: 'flex',
      gap: '24px',
      width: 'max-content',
    },
    cardWrapper: {
      width: CARD_WIDTH,
      paddingVertical: '10px',
      paddingHorizontal: '5px',
    },
    card: {
      width: '100%',
      height: '180px',
      backgroundColor: '#FFFFFF', // Fixed white background
      borderRadius: '16px',
      padding: '20px',
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      border: `3px solid ${ACCENT_COLOR}`, // Using purple accent color
      boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.1)',
    },
    contentContainer: {
      flex: 1,
      paddingRight: '16px',
    },
    title: {
      fontFamily: 'Poppins, sans-serif', // Ensure Poppins is applied
      fontSize: '16px',
      color: ACCENT_COLOR, // Using purple for text
      marginBottom: '16px',
      fontWeight: 500, // Poppins Medium
    },
    button: {
      backgroundColor: ACCENT_COLOR, // Using purple for button
      padding: '8px 16px',
      borderRadius: '8px',
      alignSelf: 'flex-start',
      border: 'none',
      cursor: 'pointer',
      transition: 'background-color 0.3s ease',
      fontFamily: 'Poppins, sans-serif', // Ensure Poppins is applied
    },
    buttonText: {
      fontFamily: 'Poppins, sans-serif', // Ensure Poppins is applied
      color: '#FFFFFF',
      fontSize: '10px',
      fontWeight: 500, // Poppins Medium
    },
    lottieContainer: {
      flex: 1,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    lottie: {
      width: '120px',
      height: '120px',
    },
  };

  // Multiply features array to create a seamless loop
  const displayFeatures = [...features, ...features, ...features];

  return (
    <div style={styles.wrapper}>
      <div style={styles.track} className="carousel-track">
        {displayFeatures.map((feature, index) => (
          <div key={index} style={styles.cardWrapper}>
            <div style={styles.card}>
              <div style={styles.contentContainer}>
                <h3 style={styles.title}>{feature.title}</h3>
                <button
                  style={styles.button}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = `${ACCENT_COLOR}dd`;
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = ACCENT_COLOR;
                  }}
                >
                  <span style={styles.buttonText}>Coming Soon</span>
                </button>
              </div>
              <div style={styles.lottieContainer}>
                <Lottie
                  animationData={feature.animation}
                  loop={true}
                  autoplay={true}
                  style={styles.lottie}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <style>
        {`
          .carousel-track {
            animation: scroll 30s linear infinite;
          }
          .carousel-track:hover {
            animation-play-state: paused;
          }
          @keyframes scroll {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(calc(-324px * ${features.length}));
            }
          }
          @media (max-width: 768px) {
            @keyframes scroll {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(calc(-304px * ${features.length}));
              }
            }
          }
        `}
      </style>
    </div>
  );
};

export default FeatureCarousel;